import { MovieCogIcon } from './MovieCogIcon';

/**
 * author: Colton Wiscombe
 * id B06E7709-247C-4F57-BFA6-345C1ABAE8C3
 * name movie-cog
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-cog.svg
 * tags
 * - Video / Movie 
 * - Settings 
 */
export const SlateCogIcon = MovieCogIcon;
export default SlateCogIcon